import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import { ReactComponent as EcommerceIcon } from '../../../assets/icons/payment-integration.svg';
import { ReactComponent as ApiIcon } from '../../../assets/icons/api-cloud.svg';
import { ReactComponent as SplitPaymentsIcon } from '../../../assets/icons/split-icon.svg';
import './styles.scss';

interface ConnectionOption {
  id: string;
  labelKey: string;
  descKey: string;
  tooltipKey: string;
  route: string;
  badge?: 'new';
  icon: React.ReactNode;
}

const Connections = () => {
  const history = useHistory();

  const options: ConnectionOption[] = [
    {
      id: 'ecommerce',
      labelKey: 'menu.subItem.PAYMENT_INTEGRATION',
      descKey: 'connections.ecommerce.desc',
      tooltipKey: 'connections.ecommerce.tooltip',
      route: Routes.PAYMENT_INTEGRATION,
      icon: <EcommerceIcon className="connections-hub__icon connections-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'api',
      labelKey: 'menu.subItem.PAYMENT_INTEGRATION_API',
      descKey: 'connections.api.desc',
      tooltipKey: 'connections.api.tooltip',
      route: `${Routes.PAYMENT_INTEGRATION}?details=API`,
      badge: 'new',
      icon: <ApiIcon className="connections-hub__icon connections-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'split-payments',
      labelKey: 'menu.subItem.SPLIT_PAYMENTS',
      descKey: 'connections.splitPayments.desc',
      tooltipKey: 'connections.splitPayments.tooltip',
      route: Routes.SPLIT_PAYMENTS,
      icon: <SplitPaymentsIcon className="connections-hub__icon connections-hub__icon--svg" aria-hidden />,
    },
  ];

  return (
    <div className="connections-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_CONEXIONES')} subtitle={l('connections.subheadline')} />
      <AlertMessages />
      <Card className="connections-hub__card">
        <div className="connections-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="connections-hub__accent-line" />}>
              <button
                type="button"
                className="connections-hub__item"
                role="listitem"
                onClick={() => history.push(option.route)}
              >
                <div
                  className="connections-hub__info"
                  onClick={e => e.stopPropagation()}
                  onKeyDown={e => e.stopPropagation()}
                >
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="connections-hub__info-icon" aria-hidden />}
                  />
                </div>
                {option.badge && (
                  <span className={`connections-hub__badge connections-hub__badge--${option.badge}`}>
                    {l(`common.tag.${option.badge}`)}
                  </span>
                )}
                <div className="connections-hub__icon-wrap">{option.icon}</div>
                <div className="connections-hub__label">{l(option.labelKey)}</div>
                <div className="connections-hub__desc">{l(option.descKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Connections;
